import React, { useEffect, useState } from "react"
import {
  getInternalLinkTypeForFindStore,
  getShortenedUrl,
  removeCharactersAfterNumber,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
import _isEmpty from "lodash/isEmpty"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import { isIOS } from "react-device-detect"

const StoreList = ({
  data,
  active,
  activeTab,
  staticTexts,
  findStoreDetails,
  findStoreCheckedId,
  handleFindStoreCheck,
  index,
  FIRST_TAB,
  isMobile,
}) => {
  const [entityIDURL, setEntityIDURL] = useState("")
  useEffect(() => {
    getShortenedUrl(
      findStoreDetails[removeCharactersAfterNumber(data?.EntityID)]
    ).then(res => {
      setEntityIDURL(res)
    })
  }, [data?.EntityID])
  const formatPhoneNumber = phoneNumberString => {
    let cleaned = ("" + phoneNumberString).replace(/\D/g, "")
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3]
    }
    return null
  }
  const getEventInfo = (type, link) => {
    let internalLinkName
    let internalLinkType = sanitizeTextForAnalytics(data?.LocationName)
    const internalLinkTypeForFindStore = getInternalLinkTypeForFindStore(
      data?.LocationName,
      data?.Locality,
      data?.StateLong
    )
    if (type === "store name") {
      internalLinkName = sanitizeTextForAnalytics(data?.LocationName)
      internalLinkType = `find a store${internalLinkTypeForFindStore}`
    } else if (type === "contact number") {
      internalLinkName = formatPhoneNumber(data?.Phone)
      internalLinkType = `find a store:${sanitizeTextForAnalytics(
        data?.LocationName
      )}`
    } else if (
      type === "set as preferred store" ||
      type === "unset as preferred store"
    ) {
      internalLinkType = `find a store:${internalLinkTypeForFindStore}`
    }
    return JSON.stringify({
      eventAction: `find a store:landing:location info:${type}`,
      eventName: `find a store:landing:location info:${type}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: internalLinkName || type,
      internalLinkPosition: "find a store",
      internalLinkType,
      internalLinkZoneName: "find a store:landing:location info​",
      internalLinkURL: link
        ? (type !== "contact number" && link?.indexOf("http") === -1
            ? window.location.origin
            : "") + link
        : "n/a",
      clickInternalLinks: "true",
    })
  }
  return (
    <div
      className={`store-list ${active && "store-list--active"}`}
      role="listitem"
    >
      <div className="row">
        <div className="col-8 col-md-4 store-list__name-col px-0">
          {activeTab !== FIRST_TAB ||
          (findStoreDetails &&
            !(
              removeCharactersAfterNumber(data?.EntityID) in findStoreDetails
            )) ? (
            <span className="store-list__name store-list__genuine-dealers gbh-data-layer">
              {data?.LocationName}
            </span>
          ) : (
            <>
              <a
                href={entityIDURL ?? "/"}
                className="store-list__name gbh-data-layer"
                aria-label="link to store name"
                data-gbh-data-layer={getEventInfo(
                  "store name",
                  entityIDURL ?? "/"
                )}
              >
                {data?.LocationName}
              </a>
            </>
          )}
        </div>
        <div className="col-12 col-md-4 store-list__address-col px-0">
          <div className="store-list__address">
            {!isMobile ? (
              <React.Fragment>
                <span>{data?.AddressLine + ","}</span>
                {!_isEmpty(data?.AddressLine2) ? (
                  <span>{data?.AddressLine2},</span>
                ) : (
                  ""
                )}
                <span>
                  {data?.Locality +
                    ", " +
                    data?.AdminDistrict +
                    " " +
                    data?.PostalCode}
                </span>
              </React.Fragment>
            ) : (
              <a
                href={
                  isIOS === true
                    ? `maps://maps.google.com/maps?daddr=${data?.Latitude},${data?.Longitude}&amp;ll=`
                    : `http://www.google.com/maps?q=${data?.Latitude},${data?.Longitude}`
                }
              >
                <span>{data?.AddressLine}</span>
                {_isEmpty(data?.AddressLine2) ? (
                  <span>{data?.AddressLine2}</span>
                ) : (
                  ""
                )}
                <span>
                  {data?.Locality +
                    ", " +
                    data?.AdminDistrict +
                    " " +
                    data?.PostalCode}
                </span>
              </a>
            )}
          </div>
          <a
            href={`tel:+${data?.Phone}`}
            className="store-list__phone gbh-data-layer"
            aria-label={`${data?.Phone} Dial this number to contact ${data?.LocationName} store`}
            data-gbh-data-layer={getEventInfo(
              "contact number",
              `tel:${formatPhoneNumber(data?.Phone)}`
            )}
          >
            {formatPhoneNumber(data?.Phone)}
          </a>
        </div>
        {data?.__Distance && (
          <div className="col-3 col-md-2 store-list__distance-col px-0">
            <div className="store-list__distance">
              {data?.__Distance?.toFixed(1) + " mi"}
            </div>
            <div className="store-list__time">{data?.OpenUntil}</div>
          </div>
        )}
      </div>

      <div className="row">
        {activeTab === FIRST_TAB && (
          <div className="col-7 px-0">
            <div className="store-list__set-store">
              <Checkbox
                analyticsData={getEventInfo(
                  `${
                    !(findStoreCheckedId === data?.EntityID) ? "unset" : "set"
                  } as preferred store`
                )}
                id={`store-list__set-store_${index}`}
                checked={findStoreCheckedId === data?.EntityID}
                value={
                  findStoreCheckedId === data?.EntityID
                    ? staticTexts.myStore
                    : staticTexts.setAsMyStore
                }
                onChange={e =>
                  handleFindStoreCheck(e.target.checked ? data?.EntityID : 0)
                }
              />
            </div>
          </div>
        )}
        {data?.OpenUntil && (
          <div className="col-5 px-0">
            <div className="store-list__set-store-time">{data?.OpenUntil}</div>
          </div>
        )}
      </div>
    </div>
  )
}
export default StoreList
